import React from 'react';
import clsx from 'clsx';
import { EVENT_TYPE_CARD_DEFAULT_META, EVENT_TYPE_CARD_META } from '../../boutique-classroom.constants';
import { getEventPaletteTone } from '../../boutique-classroom.mappers';
import { ExpertEventType } from '../../boutique-classroom.types';

interface EventTypeCardProps {
	eventType: ExpertEventType;
	index: number;
	isSelected: boolean;
	disabled?: boolean;
	onSelect: (eventType: ExpertEventType) => void;
}

export const EventTypeCard: React.FC<EventTypeCardProps> = ({ eventType, index, isSelected, disabled = false, onSelect }) => {
	const meta = EVENT_TYPE_CARD_META[eventType.code] ?? EVENT_TYPE_CARD_DEFAULT_META;
	return (
		<button
			type="button"
			role="radio"
			aria-checked={isSelected}
			disabled={disabled}
			className={clsx('event-type-card', { 'event-type-card--selected': isSelected, 'event-type-card--disabled': disabled })}
			onClick={() => onSelect(eventType)}>
			<span className={clsx('event-type-card__icon', `event-type-card__icon--${getEventPaletteTone(index)}`)}>
				<i className={meta.iconClass} />
			</span>
			<span className="event-type-card__text">
				<span className="event-type-card__title">{eventType.name}</span>
				{meta.description && <span className="event-type-card__description">{meta.description}</span>}
			</span>
		</button>
	);
};

export default EventTypeCard;
